import { Injectable, inject } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { NoState } from '@siza-staff-care/shared/data';
import { StyleService } from '@siza-staff-care/shared/global-services';
import { Observable, tap } from 'rxjs';

type Params = {
	styles: string;
	replacements?: { [key: string]: string };
};

@Injectable()
export class StylesStore extends ComponentStore<NoState> {
	private styles = inject(StyleService);

	readonly setDynamicStyles = this.effect((params$: Observable<Params>) =>
		params$.pipe(
			tap((params) => {
				this.buildStyles(params.styles, params.replacements ?? {});
			}),
		),
	);

	private buildStyles(stylesString: string, replacements: { [key: string]: string } = {}) {
		const split = stylesString.split('\r\n');

		// Remove TD tags - since we're no longer using a table to display the cells.
		// Replace font-weight: bold with font-weight: 500, to correctly set the font-weight to bold-ish.
		const withoutTd = split.map((s) => s.replace('td', '').replace('font-weight: bold', 'font-weight: 500'));

		withoutTd.forEach((s) => {
			const parsedRule = /(^.*){(.*)}/.exec(s);

			// Replace the AngularJs component selectors with equivalent Angular selectors.
			let selector = parsedRule?.[1] || '';

			Object.keys(replacements).forEach((key) => {
				selector = selector.replace(key, replacements[key]);
			});

			const styles = parsedRule?.[2] || '';
			const selectorStyles = styles.split(';');
			selectorStyles.forEach((s) => {
				const keyValue = /(^.*):(.*)/.exec(s);
				const key = (keyValue?.[1] || '').trim();
				const value = (keyValue?.[2] || '').trim();

				if (key && value) {
					this.styles.setStyle(selector, key, value);
				}
			});
		});
	}
}
